import { isBrowser } from './check-environment'

export const getDeviceId = (cookieName: string) => {
  if (!isBrowser()) {
    return
  }

  let cookie = document.cookie.split(';').find((cookie) => cookie.split('=')[0].trim() === cookieName)
  let deviceId

  if (cookie) {
    deviceId = cookie.split('=')[1]
  } else {
    deviceId = generateId()
  }

  cookie = `${cookieName}=${deviceId};path=/;${getExpires()}`
  document.cookie = cookie

  return deviceId
}

const RADIX = 36
const START_INDEX = 2
const MAX_LENGHT = 12
const FILL_STRING = '0'

// https://stackoverflow.com/questions/3231459/how-can-i-create-unique-ids-with-javascript
const generateId = () =>
  Date.now().toString(RADIX) +
  Math.random().toString(RADIX).substring(START_INDEX, MAX_LENGHT).padStart(MAX_LENGHT, FILL_STRING)


const TEN_YEARS = 31536000000

const getExpires = () => {
  const date = new Date()
  date.setTime(date.getTime() + TEN_YEARS)
  const expires = `expires=${date.toUTCString()}`

  return expires
}
